import React, { Component } from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import classnames from 'classnames';
import { SearchSelect } from 'lib';

import { getEquipmentColorClass } from 'helpers/_helpers';
import styles from './styles';

class SearchForm extends Component {
  state = {
    picks: 0,
  };

  onSelectValue = (id) => {
    const item = this.props.list.find((option) => option.id === id);
    if (!item) return;

    this.props.selectItem(item.id);
    this.setState((prev) => ({ picks: prev.picks + 1 }));
  };

  getEquipmentInfo = (field, item) => {
    if (!item) return '';
    if (field === 'number') {
      return item.number || parseInt(item.name);
    }
    if (field === 'className') {
      return getEquipmentColorClass(item.color);
    }
    return item[field];
  };

  itemRender = (item) => {
    const { classes, type, usedItems } = this.props;
    const isUsedResource = usedItems.find((r) => r._id === item._id);

    return type === 'people' ? (
      <div
        className={classnames(
          classes.userWrapper,
          isUsedResource && classes.usedResource,
          classes[item.info.profile.shifts.timeOfDay.toLowerCase()]
        )}
        key={item.id}
      >
        {item.label}
      </div>
    ) : (
      <div className={classes.userWrapper} key={item.id}>
        <div
          className={classnames(
            classes.equipmentBlock,
            isUsedResource && classes.usedResource,
            this.getEquipmentInfo('className', item.info)
          )}
        >
          <div
            className={classes.equipmentNumber}
            style={{ backgroundColor: this.getEquipmentInfo('color', item.info) }}
          >
            {this.getEquipmentInfo('number', item.info)}
          </div>
          <div
            className={classes.equipmentName}
            style={{ color: this.getEquipmentInfo('color', item.info) }}
          >
            {item.info.name}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { classes, list, type } = this.props;

    return (
      <div className={classes.searchWrapper}>
        <div className={classes.searchIcon}>
          <SearchIcon />
        </div>
        <SearchSelect
          // remounting empties the input: picking assigns the resource, the field never holds one
          key={this.state.picks}
          value={null}
          onChange={this.onSelectValue}
          options={list}
          getOptionId={(item) => item.id}
          getOptionLabel={(item) => item.label}
          renderOption={this.itemRender}
          classes={{ root: classes.search, input: classes.searchInput }}
          inputProps={{ placeholder: `Search for ${type}` }}
        />
      </div>
    );
  }
}

SearchForm.propTypes = {
  classes: propTypes.object.isRequired,
  list: propTypes.array.isRequired,
  type: propTypes.string.isRequired,
  selectItem: propTypes.func.isRequired,
  usedItems: propTypes.array.isRequired,
  unavailableResources: propTypes.array.isRequired,
};

export default withStyles(styles)(SearchForm);
